module.exports = __webpack_public_path__ + "img/ZA.8f273c29.svg";